module.exports = __webpack_public_path__ + "img/2022_chrysler-pacifica.c7a60447.png";